// @flow

import BaseDataModel from './base';

import type { IDataModel } from '../contracts';

export default class DefaultDataModel
	extends BaseDataModel
	implements IDataModel {}